module.exports = __webpack_public_path__ + "static/img/photoN.cdc2beb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/photoN.png
// module id = 4W0k
// module chunks = 0